import { render, staticRenderFns } from "./OpenIcon.vue?vue&type=template&id=dc8fd23e"
import script from "./OpenIcon.vue?vue&type=script&lang=js"
export * from "./OpenIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports